import type {LinkedIssuePullRequest} from './types'

export function getTaskStateLabel(state: string, pullRequest: LinkedIssuePullRequest | null): string {
  if (state === 'waiting_for_user') return 'Needs attention'
  if (state === 'completed') {
    if (!pullRequest) return 'Done'

    if (pullRequest.state === 'OPEN') return 'Ready for review'
    if (pullRequest.state === 'MERGED') return 'Merged'
    if (pullRequest.state === 'CLOSED') return 'Closed'

    return 'Done'
  }
  if (state === 'failed' || state === 'timed_out') return 'Failed'
  if (state === 'cancelled') return 'Cancelled'
  if (state === 'in_progress' || state === 'running') return 'Working'
  if (state === 'queued') return 'Queued'
  if (state === 'idle') return 'Idle'
  if (state === 'stopped') return 'Stopped'
  return 'Unknown'
}
